// Gallery thumbnails swap the main image; size buttons update the price and the variant sent to checkout.
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.gallery__thumb');
  if (!thumb) return;
  const gallery = thumb.closest('[data-gallery]');
  const main = gallery.querySelector('.js-gallery-main');
  main.removeAttribute('srcset');
  main.src = thumb.dataset.src;
  main.alt = thumb.dataset.alt || '';
  gallery.querySelectorAll('.gallery__thumb').forEach((t) => t.removeAttribute('aria-current'));
  thumb.setAttribute('aria-current', 'true');
});

// The form posts a single hidden "id" input. Buy with Shop reads that input, so it must follow the picked size.
const syncVariant = (input) => {
  const hidden = input.closest('form')?.querySelector('.js-variant-id');
  if (hidden) hidden.value = input.value;
};

document.addEventListener('change', (e) => {
  const input = e.target.closest('.size-pill input');
  if (!input) return;
  syncVariant(input);
  const price = input.closest('.product-info').querySelector('[data-price]');
  if (price && input.dataset.price) price.textContent = input.dataset.price;
});

// Browsers can restore a checked size on back/forward; keep the hidden input in step.
window.addEventListener('pageshow', () => {
  document.querySelectorAll('.size-pill input:checked').forEach(syncVariant);
});
